import createModule from "../createModule"
import view from "./view"
import { Creators as ProfileCreators } from "model/profileModal"
import { Creators } from "modules/home-layout/model"
import { getModels } from "resources/models"
import { getModel } from "./selectors/model"
import "./style.scss"

export default createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
  }),
  required: ["account"],
  mapStateToProps: (state, props) => ({
    model: getModel(state, props),
    models: getModels(state),
  }),
  actions: {
    openSecurityProfile: ProfileCreators.openSecurityProfile2,
    openFactorProfile: ProfileCreators.openFactorProfile,
    ...Creators,
  },
})
